var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.taskId)?_c('div',{staticClass:"dropzone",staticStyle:{"visibility":"hidden"}},[_c('div',{staticClass:"textnode"},[_vm._v(" Перетащите файлы для загрузки... ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }